/* eslint react/prop-types: 0 */
import React from 'react';
import classNames from 'classnames';
import { buildHandleEnterKeyPress } from 'utils/a11y';

const NavButton = ({ disabled, onClick, children, href, ariaLabel }) => {
  const styleName = classNames(
    'Pagination-navButton',
    'Pagination-buttonText',
    {
      'Pagination-navButton--disabled': disabled,
    },
  );

  return (
    <li className={styleName}>
      <a
        tabIndex="0"
        role="button"
        href={href}
        onKeyPress={onClick ? buildHandleEnterKeyPress(onClick) : null}
        onClick={onClick || null}
        aria-label={disabled ? `${ariaLabel}: Disabled` : ariaLabel}
      >
        {children}
      </a>
    </li>
  );
};

export default NavButton;
